import { render } from "./OrderDetailsLeftCol.vue?vue&type=template&id=195894f0"
import script from "./OrderDetailsLeftCol.vue?vue&type=script&lang=js"
export * from "./OrderDetailsLeftCol.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__